import React from "react";
import clsx from "clsx";
import { makeStyles } from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";
import Button from "@material-ui/core/Button";
import List from "@material-ui/core/List";
import Divider from "@material-ui/core/Divider";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import HomeIcon from "@material-ui/icons/Home";
import MenuIcon from "@material-ui/icons/Menu";
import ContactMailIcon from "@material-ui/icons/ContactMail";
import ExtensionIcon from "@material-ui/icons/Extension";
import SettingsEthernetIcon from "@material-ui/icons/SettingsEthernet";
//Material UI
import AppleIcon from '@material-ui/icons/Apple';
import AndroidIcon from '@material-ui/icons/Android';
import InstagramIcon from '@material-ui/icons/Instagram';
import { Apple } from "@material-ui/icons";

const useStyles = makeStyles({
  list: {
    width: 250,
  },
  fullList: {
    width: "auto",
  },
});

export default function TemporaryDrawer() {
  const classes = useStyles();
  const [state, setState] = React.useState({
    right: false,
  });

  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setState({ ...state, [anchor]: open });
  };

  const list = (anchor) => (
    <div
      className={clsx(classes.list, {
        [classes.fullList]: anchor === "top" || anchor === "bottom",
      })}
      role="presentation"
      onClick={toggleDrawer(anchor, false)}
      onKeyDown={toggleDrawer(anchor, false)}
    >
      <List className="menu">
      <ListItem button>
          <ListItemIcon>
            <HomeIcon />
          </ListItemIcon>
          <ListItemText>Home</ListItemText>
        </ListItem>
        <a href="https://www.instagram.com/exude.social/">
        <ListItem button>
          <ListItemIcon>
            <InstagramIcon />
          </ListItemIcon>
          <ListItemText>Instagram</ListItemText>
        </ListItem>
        </a>
        <a href="#">
        <ListItem button>
          <ListItemIcon>
            <AppleIcon />
          </ListItemIcon>
          <ListItemText>Apple Store</ListItemText>
        </ListItem>
        </a>
        <a href="#">
        <ListItem button>
          <ListItemIcon>
            <AndroidIcon />
          </ListItemIcon>
          <ListItemText>Play Store</ListItemText>
        </ListItem>
        </a>
        <a class="mailto" href="mailto:info.exude@gmail.com">
        <ListItem button>
          <ListItemIcon>
            <ContactMailIcon />
          </ListItemIcon>
          <ListItemText>Collaborate</ListItemText>
        </ListItem>
        </a>
      </List>
      <Divider />
    </div>
  );

  return (
    <div className="menuwrapper">
      {["right"].map((anchor) => (
        <React.Fragment key={anchor}>
          <Button className="menubtn" onClick={toggleDrawer(anchor, true)}>
            <MenuIcon style={{ fontSize: "50px" }} />
          </Button>
          <Drawer
            anchor={anchor}
            open={state[anchor]}
            onClose={toggleDrawer(anchor, false)}
          >
            {list(anchor)}
          </Drawer>
        </React.Fragment>
      ))}
    </div>
  );
}
